import {
    ApiBounds,
    ApiConstructabilityIssue,
    ApiConversation,
    ApiMessage,
    GenerateSpreadsheetArgs,
} from "../shared/interfaces";

function safeDateCompareAsc(a: Date, b: Date): number {
    return new Date(a).getTime() - new Date(b).getTime();
}

export function comparatorMessageOldToNew(a: ApiMessage, b: ApiMessage): number {
    return safeDateCompareAsc(a.createdAt, b.createdAt);
}

export function comparatorMessageNewToOld(a: ApiMessage, b: ApiMessage): number {
    return safeDateCompareAsc(b.createdAt, a.createdAt);
}

export function conversationLastUpdate(c: ApiConversation) {
    if (!c.messages || c.messages.length === 0) {
        return c.updatedAt;
    }

    return c.messages.sort(comparatorMessageOldToNew)[c.messages.length - 1].createdAt;
}

export function comparatorConversationOldestToNewestUpdate(a: ApiConversation, b: ApiConversation) {
    return safeDateCompareAsc(conversationLastUpdate(a), conversationLastUpdate(b));
}

export function comparatorConversationNewestToOldestUpdate(a: ApiConversation, b: ApiConversation) {
    return safeDateCompareAsc(conversationLastUpdate(b), conversationLastUpdate(a));
}

export function comparatorIssueNumber(a: ApiConstructabilityIssue, b: ApiConstructabilityIssue) {
    return a.issueNumber - b.issueNumber;
}

export function getMessageForSpreadsheetArgs(args: GenerateSpreadsheetArgs): string {
    return JSON.stringify({
        function: "GenerateSpreadsheet",
        data: args,
    });
}

export function copyToClipboardOrShowAlert(content: string) {
    navigator.clipboard.writeText(content).catch((_) => alert("Not able to copy."));
}

export function bytesToMegabytes(bytes: number): string {
    const mb = bytes / (1024 * 1024);
    return mb.toFixed(1);
}

export const getIdForBounds = (bounds: ApiBounds): string => {
    return (
        `annot-${bounds.page}-${bounds.xMin.toFixed(2)}-` +
        `${bounds.yMin.toFixed(2)}-${bounds.xMax.toFixed(2)}-${bounds.yMax.toFixed(2)}`
    );
};
